<template>
	<el-drawer :visible.sync="dialogShow" direction="rtl" :size="560" :show-close="false" :append-to-body="true">
		<template slot="title">
			<span class="font-lg text-bold text-black">项目成员</span>
		</template>
		<div class="flex column" style="height:100%">
			<div class="font-lg text-bold text-muted pl ft">
				成员列表（{{list.length}}）
			</div>
			<ul class="member-list bd">
				<li v-for="item in list" :key="'member'+item.uid" class="flex list-item">
					<span class="bd flex align-items-center">
						<f-user-avatar :user="item" :preview="false" size="large" role="button" />
						<!-- <img v-if=" item.avatar" :src="item.avatar" alt="" class="image large circle" />
						<img v-else src="@/assets/default-avatar.png" alt="" class="image circle large" /> -->
						<span class="ml-xs ellipsis">{{ item.username }}</span>
					</span>
					<span class="ft flex-center">
						<level-pulldown :item="item" :disabled="$store.state.middleStore.proDetail.principal==item.uid" @change="handleMemberChange($event,item.uid)" />
					</span>
				</li>
			</ul>
			<div class="ft flex-center pt-sm pb-sm" style="border-top: 1px solid rgba(0, 0, 0, 0.1)">
				<el-button type="primary" size="small" @click="showAdd=true">添加成员</el-button>
			</div>
		</div>
		<add-member v-if="showAdd" :show.sync="showAdd" @success="$store.dispatch('setTeamMember', { projectid: $store.state.middleStore.tmpProjectid })" />
	</el-drawer>
</template>

<script>
import AddMember from './AddMember.vue'
import LevelPulldown from './LevelPulldown.vue'
import { editMemberApi } from '@/api/pm/memberApi'

export default {
	components: {
		LevelPulldown,
		AddMember
	},
	props: {
		show: {
			type: Boolean
		}
	},

	data () {
		return {
			showAdd: false
		}
	},
	computed: {
		dialogShow: {
			get () {
				return this.show
			},
			set (val) {
				this.$emit('update:show', val)
			}
		},
		list () {
			return this.$store.state.middleStore.TeamMember
		},
		pid () {
			return Number(this.$store.state.middleStore.tmpProjectid)
		}
	},
	methods: {
		togglePanel (item) {
			this.$refs['mDown' + item.uid].togglePanel()
		},

		handleMemberChange (e, uid) {
			let data = {
				projectid: this.pid,
				uid: uid,
				permission: e
			}
			if (e != 4) {
				editMemberApi(data).then((res) => {
					if (!res.errno) {
						this.$message.success('修改成功！')
					}
					this.$store.dispatch('setTeamMember', { projectid: this.$store.state.middleStore.tmpProjectid })
				})
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.member-list {
	padding: 10px 20px;
	.list-item {
		padding: 6px 20px;
		&:hover {
			background-color: rgba(245, 247, 250, 1);
		}
	}
}
</style>